import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";

const boxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "70%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export interface PromoteToResellerModalDelegate {
  onConfirm: () => void;
  onClose: () => void;
}

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  userName: string;
  delegate: PromoteToResellerModalDelegate;
}

export function PromoteToResellerModal({
  isOpen,
  isLoading,
  userName,
  delegate,
}: Props) {
  return (
    <Modal open={isOpen} onClose={delegate.onClose}>
      <Box sx={boxStyle}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <Typography
              variant="h5"
              component="h2"
              color="primary"
              fontWeight="bold"
            >
              Promover para Revendedor
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Tem certeza de que deseja promover o usuário{" "}
              <strong>{userName}</strong> para o perfil de Revendedor?
            </Typography>
            <Typography sx={{ mt: 1, fontSize: "0.9rem" }}>
              Ele ganhará acesso ao painel de gerenciamento de clientes e
              distribuição de licenças. Esta ação não pode ser facilmente
              desfeita.
            </Typography>
            <Box
              m={2}
              display="flex"
              flexDirection="row"
              justifyContent="center"
            >
              <Button
                variant="contained"
                color="primary"
                onClick={delegate.onConfirm}
                sx={{ margin: 1, color: "white" }}
              >
                Confirmar Promoção
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={delegate.onClose}
                sx={{ margin: 1 }}
              >
                Cancelar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
